<template>
  <app-modal
    v-bind="$attrs"
    class="confirm-modal-container"
    content-class="modal-error"
    title="エラー"
  >
    <template v-slot:body="{ cancel }">
      <div class="modal-body text-pre-wrap pa-4">
        <template v-if="isGET">
          該当するデータが存在しませんでした。画面を更新してもう一度やり直してください。</template
        >
        <template v-else>
          {{ error?.data.errorMessage }}
        </template>
      </div>

      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              v-if="isGET"
              variant="outlined"
              color="primary"
              @click="refresh"
              >更新</v-btn
            >
            <v-btn v-else variant="outlined" color="primary" @click="cancel"
              >閉じる</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { ApiRequestError } from "@/error/errors";

export default defineComponent({
  name: "ApiNotFoundModal",
  props: {
    /** エラー. 指定が無い場合は固定メッセージ表示 */
    error: {
      type: ApiRequestError as PropType<ApiRequestError>,
      required: false,
    },
  },
  computed: {
    /** true: GETリクエスト or エラー指定無し, false: GETリクエストではない */
    isGET(): boolean {
      return this.error
        ? this.error.axiosError.config!.method?.toUpperCase() === "GET"
        : true;
    },
  },
  methods: {
    refresh() {
      window.location.reload();
    },
  },
});
</script>
